import Vue from 'vue';
import axios from 'axios';
import App from './Im.vue';
import EventBus from './event-bus';
import store from './store';

Vue.prototype.$axios = axios;
Vue.prototype.$bus = EventBus;

class Im {
  init() {
    this.resizeTimeout = null;
    this.baseHeigth = null;
    this.privatBody = document.querySelector('.classPrivat_Body');
    if (this.privatBody) {
      this.setHeightContainerLayers();
      this.setHeightContacts();
      this.bind();
    } else {
      let IMdiv = document.getElementById('im');
      new Vue({
        store,
        render: h =>
          h(App, {
            props: {
              userTo: IMdiv.attributes['data-user-to'].value,
              userAuthID: IMdiv.attributes['data-user-auth-id'].value
            }
          })
      }).$mount('#im');
    }
  }

  bind() {
    window.addEventListener(
      'resize',
      () => {
        this.resizeThrottler();
      },
      false
    );
  }

  resizeThrottler() {
    if (!this.resizeTimeout) {
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = null;
        this.resize();
      }, 100);
    }
  }

  resize() {
    this.setHeightContainerLayers();
    this.setHeightContacts();
  }

  setHeightContainerLayers() {
    const el = document.querySelector('.classPrivat_Layer_Container.Layers');
    if (el) {
      const offsetTop = el.getBoundingClientRect().top + window.scrollY;
      const height = window.innerHeight - offsetTop;
      el.style.height = `${height}px`;
    }
  }

  setHeightContacts() {
    const getClientRect = selector => {
      const elem = document.querySelector(selector);
      if (elem) {
        return document.querySelector(selector).getBoundingClientRect();
      }
      return null;
    };
    const body = getClientRect('.classPrivat_Body');
    const contacts = getClientRect('.classPrivat_Contacts');
    const banners = getClientRect('.banners-cont');
    if (banners && banners.height > contacts.height) {
      this.baseHeigth = banners.height;
    } else {
      this.baseHeigth = window.innerHeight - body.top;
    }
    const elContacts = document.querySelector('.classPrivat_Contacts');
    const elSlider = document.querySelector('.classPrivat_Contacts_Slider');
    elContacts.style.height = `${this.baseHeigth}px`;
    elSlider.style.height = `${this.baseHeigth}px`;
  }
}

const documentReady = callback => {
  if (document.readyState === 'interactive') {
    callback();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        callback();
      },
      false
    );
  }
};

documentReady(() => {
  const im = new Im();
  im.init();
});
